import GiftCardBalanceChecker from '@ulta/components/GiftCardBalanceChecker/GiftCardBalanceChecker';

export default GiftCardBalanceChecker;